import { useAppSelector } from "../store/hook";

// Display name of the logged-in admin's LoB (e.g. "India", "Malaysia"), or null.
export const useLobName = () => useAppSelector((state) => state.lobConfig.lobName);
